import React from "react";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="max-w-screen-xl mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full space-y-3">
          <p className="text-sm text-[#64ffda] font-bold font-mono">
            Hi, my name is
          </p>
          <br></br>
          <h2 className="md:text-4xl lg:text-5xl sm:text-6xl font-bold text-[#ccd6f6] font-serif">
            kamrunnahar Somapti.
          </h2>

          {/* <h3 className="text-4xl sm:text-6xl font-bold text-white">
            kamrunnahar Somapti
          </h3> */}
          <h2 className="md:text-4xl lg:text-5xl font-bold py-4 text-[#ccd6f6] font-serif">
            I create beautiful websites and web applications.
          </h2>
          <p className="w-[540px] text-[#8892b0] font-sans text-xl py-3">
            I'm a Front End Engineer from Bangladesh. Focused on building
            websites with JavaScript. Interested in design, under engineering
            and open source.
          </p>

          <button
            to="portfolio"
            smooth
            duration={500}
            className="group  w-fit px-6 py-3  flex items-center border border-[#64ffda] text-[#64ffda] hover:bg-[rgba(100,255,218,0.1)] cursor-pointer"
          >
            <a href="https://drive.google.com/file/d/18EGp_ecMxycfCARjxpRt6Vb3xaXRTlDR/view?usp=sharing">
              {" "}
              Check Out my resume!
            </a>
            <span className="group-hover:rotate-90 duration-300"></span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
